import { ColumnsType } from 'antd/lib/table';
import { EmployeesUi } from 'entities/employees';
import { ImportPreviewTableRow } from 'entities/ui/model/absence';
import { shallowEqual } from 'react-redux';
import { SorterResult } from 'antd/lib/table/interface';
import style from '../index.module.scss';
import { ButtonDelete } from '../ui/button-delete';
import { ColumnTypes } from '../ui/preview';
import { isError, sortByPersonnelNumber } from '../helpers';

const sharedOnCell = (record: ImportPreviewTableRow) => {
  if (record.errors?.employee) {
    return { colSpan: 0 };
  }
  return {};
};

export const importPreviewColumns = (
  sortedInfo: SorterResult<ColumnTypes[number]>,
): (ColumnsType<ImportPreviewTableRow>[number] & {
  editable?: boolean;
  dataIndex?: string;
})[] => {
  return [
    {
      title: '№',
      dataIndex: 'tableId',
      key: 'id',
      width: 40,
      align: 'center',
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
      sorter: {
        compare: (a, b) => (isError(a) && !isError(b) ? 1 : -1),
      },
      sortOrder: sortedInfo.columnKey === 'id' ? sortedInfo.order : null,
      sortDirections: [],
    },
    {
      title: 'Сотрудник',
      ellipsis: true,
      key: 'personnelNumber',
      render: (text, record) => {
        const { name, middleName, lastName, personnelNumber } = record;
        return record.errors?.employee ? (
          <span>{record.errors?.employee}</span>
        ) : (
          <div>
            <EmployeesUi.SummaryInfo
              user={{ id: personnelNumber, name, middleName, lastName, personnelNumber }}
              initials
              bold
              showPersonnelNumber={false}
            />
            <div>{record.personnelNumber}</div>
          </div>
        );
      },
      onCell: record => ({
        colSpan: record.errors?.employee ? 5 : 1,
      }),
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
      sorter: {
        compare: sortByPersonnelNumber,
      },
      sortOrder: sortedInfo.columnKey === 'personelNumber' ? sortedInfo.order : null,
      sortDirections: [],
    },
    {
      title: 'Должность и подразделение',
      render: (text, record) => {
        const { position, division } = record;
        return record.errors?.employee ? null : (
          <div className={style.employee}>
            <span className={style.elipsis}>{position}</span>
            <span className={style.elipsis}>{division}</span>
          </div>
        );
      },
      onCell: sharedOnCell,
      ellipsis: true,
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
    },

    {
      title: 'Описание',
      width: 200,
      render: (text, record) => {
        const { description } = record;
        return record.description ? null : (
          <div className={style.date}>
            <span>{description}</span>
          </div>
        );
      },
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
    },
    {
      title: 'Дата начала',
      dataIndex: 'startedAt',
      width: 150,
      editable: true,
      render: (text, record) => {
        const children = record.errors?.employee ? null : (
          <div className={style.date}>
            <span>{record.startedAt}</span>
          </div>
        );

        return { children, props: { colSpan: record.errors?.employee ? 0 : 1 } };
      },
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
    },
    {
      title: 'Дата окончания',
      dataIndex: 'endedAt',
      width: 150,
      editable: true,
      render: (text, record) => {
        const children = record.errors?.employee ? null : (
          <div className={style.date}>
            <span>{record.endedAt}</span>
          </div>
        );
        const obj = { children, props: { colSpan: record.errors?.employee ? 0 : 1 } };
        return obj;
      },
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
    },
    {
      title: '',
      align: 'center',
      render: (text, record) => !record.errors?.employee && <ButtonDelete id={record.tableId} />,
      onCell: sharedOnCell,
      shouldCellUpdate: (record, prevRecord) => !shallowEqual(record, prevRecord),
    },
  ];
};
